import {
	EVENTS, REFRESH_REASONS
} from './constants';
import DpitCoreSticky from './DpitCoreSticky';
import DpitHooks from '../../../../../includes/assets/js/modules/DpitHooks';
import {
	removeURLParameters,
	absToRelativeUrl,
	initStepParams,
	unifyUrl
} from '../../../../../includes/assets/js/modules/dpitUtilsInc';
import { TargetType } from '../../apps/TourStepEditor/store/appMode';
import DpitBB from './DpitBB';
import { i18n } from '../dpitUtilsPublic';


export const LAYER_CLASSES_BUILDER = {
	builderMode: 'dpit-builder-mode',
	builderInRun: 'dpit-bon',
	builder: 'dpit-builder',
	stepEditMode: 'dpit-step-edit-mode',
	targetSelectingMode: 'dpit-target-selecting',
	hovered: 'dpit-hovered'
};

export default class DpitBuilderCore extends DpitCoreSticky {
	constructor(wrapEl, mainCfg, tourCfg) {
		if (mainCfg.dpDebugEn) console.log('[dpit] INIT DpitBuilderCore');
		super(wrapEl, mainCfg, tourCfg);

		this.tourCfg = tourCfg;
		this.mainCfg = mainCfg;
		this.optionsOverride = {
			exitOnOverlayClick: false,
			exitOnEsc: false,
			//centerTopBottomPosOffset: 120,
			leaveOverlayAlways: true
		};

		this.options = { ...this.options, ...this.optionsOverride };
		DpitHooks.init(mainCfg.dpDebugEn);
		DpitHooks.addAction(EVENTS.onInit, () => {
			if (this.buttonPrevEl) {
				$(this.buttonPrevEl).hover(
					() => this.doAction(EVENTS.onButtonHover, { id: 'back', hoverIn: true }),
					() => this.doAction(EVENTS.onButtonHover, { id: 'back', hoverIn: false })
				);
			}

			if (this.buttonNextEl) {
				$(this.buttonNextEl).hover(
					() => this.doAction(EVENTS.onButtonHover, { id: 'next', hoverIn: true }),
					() => this.doAction(EVENTS.onButtonHover, { id: 'next', hoverIn: false })
				);
			}
		});

		document.documentElement.classList.add(LAYER_CLASSES_BUILDER.builderMode);
	}

	setAsEditMode(isEditMode) {
		if (isEditMode) {
			document.documentElement.classList.add(LAYER_CLASSES_BUILDER.stepEditMode);
		} else {
			document.documentElement.classList.remove(LAYER_CLASSES_BUILDER.stepEditMode);
		}
	}


	/**
	* Start a new intro tour
	*
	* @api private
	* @method startByFirstStepItem
	*/
	startByFirstStepItem(firstStepItem) {
		this.hideIntroLayers(false, true, true);
		this.stepItems = [firstStepItem];
		this.actualizeCurrentStep(firstStepItem);
		this.startCoreBasic(false, firstStepItem.stepIdx);
		//this.showIntroLayers();
	}

	startCore(isBackward = false, startStep = 0) {
		if (this.mainCfg.builderMode !== TargetType.TRIGGER) {
			super.startCore(isBackward, startStep);
		}
	}

	showBackgroundOverlay() {
		if (this.mainCfg.builderMode !== TargetType.TRIGGER) {
			super.showBackgroundOverlay();
		}
	}

	initSteps() {
		const isAnyStepItem = super.initSteps();
		this.doAction(EVENTS.onNoStepsInit);
		return isAnyStepItem;
	}

	setInRunClasses() {
		document.documentElement.classList.add(LAYER_CLASSES_BUILDER.builderInRun);
		super.setInRunClasses();
	}

	clearInRunClasses() {
		document.documentElement.classList.remove(LAYER_CLASSES_BUILDER.builderInRun);
		super.setInRunClasses();
	}

	shouldBeStepSkipped(stepItem, isTargetInMobileMenu) {
		if (this.mainCfg.builderMode === TargetType.STEP && !this.mainCfg.mobileAltStepMode) {
			return super.shouldBeStepSkipped(stepItem, isTargetInMobileMenu);
		}
		else return false;
	}

	static initBuilderContainer(mainElement) {
		let dpIntroBuilderContainer = document.createElement('div');
		dpIntroBuilderContainer.className = LAYER_CLASSES_BUILDER.builder;
		mainElement.appendChild(dpIntroBuilderContainer);
		return dpIntroBuilderContainer;
	}

	pauseTour(addDocumentClass = '', leaveActiveOverlay = false) {
		if (!leaveActiveOverlay) {
			this.hideShadowOverlay();
			this.hideBackgroundOverlay();
		}
		if (this.mainCfg.builderMode === TargetType.STEP)
			super.pauseTour(addDocumentClass);
	}

	restoreTour(removeDocumentClass = '', reason = REFRESH_REASONS.restore, firstStepItem = null) {
		if (!this.showIntroLayersDisabled) this.showShadowOverlay();
		if (this.mainCfg.builderMode === TargetType.STEP) {
			if (firstStepItem) {
				this.stepItems = [firstStepItem];
				this.actualizeCurrentStep(firstStepItem);
			}
			this.actualizeThemeSpecifier(this.tourCfg.theme);
			super.restoreTour(removeDocumentClass, reason);
		}
	}

	getOnBeforeUnloadByLinkClickConfirmMessage() {
		return i18n('end-a-tour-builder-q', this.mainCfg.i18n);
	}

	actualizeNavigButtonHoverState(isNextButton, isHovered) {
		const element = isNextButton ? this.buttonNextEl : this.buttonPrevEl;
		if (isHovered) {
			element.classList.add(LAYER_CLASSES_BUILDER.hovered);
		} else {
			element.classList.remove(LAYER_CLASSES_BUILDER.hovered);
		}
	}


	showIntroLayers(showWrapper = true) {
		if (!this.showIntroLayersDisabled) super.showIntroLayers(showWrapper);
	}

	stepObject4Hooks(stepItem) {
		return stepItem ?? null;
	}

	setOptions(options) {
		super.setOptions({ ...options, ...this.optionsOverride });
	}


	onSkipButtonClick() {
		alert(this.mainCfg.i18n.tour_ending_in_builder);
	}

	actualizeEditPanelEl() {
		if (!this.editPanelEl) this.editPanelEl = document.querySelector('.dp-pull-out-panel');
		if (this.editPanelEl) this.editPanelBB = DpitBB.fromElement(this.editPanelEl, true);
		else this.editPanelBB = null;
	}

	isStickyEditPanel() {
		return this.winBB && this.winBB.width <= 480; // edit panel sticky on bottom under 480px
	}

	isStickyEditPanelOpened() {
		this.actualizeEditPanelEl();
		return this.isStickyEditPanel() && this.editPanelEl?.classList.contains('dp-pull-out-panel--active');
	}

	forceScrollTopOffset() {
		return this.isStickyEditPanelOpened();
	}


	filterWinBoardMargin(margin) {
		margin = super.filterWinBoardMargin(margin);
		if (this.isStickyEditPanelOpened()) {
			const builderEditPanelBB = DpitBB.fromElement(this.editPanelEl, true);
			if (builderEditPanelBB) {
				margin.bottom = builderEditPanelBB.height + this.options.defaultBoardMarginPx.y * this.options.defaultWinBoardMarginMobSizeCoef;
			}
		}
		return margin;
	}

	filterTooltipElRelPos(elRelPos) {
		if (this.isDummyMode() && this.isStickyEditPanelOpened() && this.winBB && this.winBoardBB && this.tooltipBB && this.targetBB) {
			if (this.tooltipBB.height >= this.winBoardBB.height) {
				elRelPos.top = this.winBoardBB.top - this.targetBB.top;
			}
			else {
				const freeHeight = this.editPanelBB ? this.winBB.height - this.editPanelBB.height : this.winBoardBB.height;
				elRelPos.top = (freeHeight - this.tooltipBB.height) / 2 - this.targetBB.top;
			}
		}
		return elRelPos;
	}

	addNewStepAt = (stepIdx = null) => {
		if (stepIdx === null) stepIdx = this.stepIdx;

		const currentUrl = removeURLParameters(window.location.href, this.mainCfg.queryParamsDefs);
		const currentUrlRel = absToRelativeUrl(currentUrl, this.mainCfg.siteUrl);

		const newStepBasic = {
			...initStepParams(this.mainCfg.stepDefinitions),
			isNewStep: true,
			idx: stepIdx,
			step: stepIdx + 1,
			url: stepIdx > 0 ? '$keep-prev-step-url' : unifyUrl(currentUrlRel, false)
		};

		const newStep = {
			...newStepBasic,
			selector: newStepBasic.element,
			element: $(newStepBasic.element)[0] || null,
			url: stepIdx > 0 ? '$keep-prev-step-url' : currentUrl
		};

		if (stepIdx < this.stepItems.length) {
			for (let i = stepIdx; i < this.stepItems.length; i++) {
				const stepItem = this.stepItems[i];
				this.updateIndexOfStepItem(stepItem, stepItem.idx + 1);
			}
		}
		if (this.options.showBullets) {
			$(this.bulletsLayer).find('ul').append(this.createBullet(this.stepItems.length + 1, true, false, this.onNavigBulletClick.bind(this)));
		}
		this.stepItems.splice(stepIdx, 0, newStep);
		return {
			stepItemBase: newStepBasic,
			stepItem: newStep
		};
	};

	removeStepAt = (stepIdx = null) => {
		if (stepIdx === null) stepIdx = this.stepIdx;
		const isAtEnd = stepIdx === this.stepItems.length - 1;
		if (stepIdx < this.stepItems.length) {
			for (let i = stepIdx; i < this.stepItems.length; i++) {
				const stepItem = this.stepItems[i];
				this.updateIndexOfStepItem(stepItem, stepItem.idx - 1);
			}
		}
		this.stepItems.splice(stepIdx, 1);
		const newStepIdx = isAtEnd ? this.stepIdx - 1 : this.stepIdx;
		if (this.options.showBullets) {
			$(this.bulletsLayer).find('ul li:last-child').remove();
		}
		return newStepIdx >= 0 ? this.stepItems[newStepIdx] : null;
	};

}